<template>
  <Toaster
    position="bottom-left"
    close-button
    :expand="false"
    :toast-options="{
      classes: {
        toast: 'toast',
        error: 'toast-error',
        warning: 'toast-warning',
        success: 'toast-success',
        info: 'toast-info',
        closeButton: 'toast-close-button',
      }
    }" />
</template>

<script lang="ts" setup>
import "vue-sonner/style.css";
import { Toaster } from "vue-sonner";
</script>

<style lang="scss">
 .toast[data-sonner-toast] {
  padding: 1rem !important;
  border-radius: var(--border-radius);
  font-size: 1rem;
  width: var(--width);
  display: flex;
  align-items: center;
  gap: 6px;

  .toast-close-button {
    color: white;
    border-width: 2px;
    border-style: solid;
    border-color: white;
  }

  &.toast-error {
    background: var(--c-red);
    border-color: var(--c-red);
    color: white;
    > .toast-close-button {
      background: var(--c-red);
      &:hover {
        background: inherit;
        border-color: inherit;
      }
    }
  }
  &.toast-success {
    background: var(--c-teal);
    border-color: var(--c-teal);
    color: white;
    > .toast-close-button {
      background: var(--c-teal);
      &:hover {
        background: inherit;
      }
    }
  }

  &.toast-warning {
    background: var(--c-orange);
    border-color: var(--c-orange);
    color: white;
    > .toast-close-button {
      background: var(--c-orange);
      &:hover {
        background: inherit;
      }
    }
  }

  &.toast-info {
    background: var(--c-cyan);
    border-color: var(--c-cyan);
    color: white;
    > .toast-close-button {
      background: var(--c-cyan);
      &:hover {
        background: inherit;
      }
    }
  }
}
</style>